import React from 'react';
import { Navigate } from 'react-router-dom';

const SubscriptionsV2Tab = React.lazy(() => import('../views/subscriptions/page'));

export const SubscriptionsRoute = () => <SubscriptionsV2Tab />;

export const BetaSubscriptionsRoute = () => <Navigate to="../subscriptions" replace />;
